import type { NavLink } from '@/types';

/**
 * Company information constants
 */
export const COMPANY_NAME = 'Service Route';
export const COMPANY_WEBSITE = 'serviceroute.io';
export const COMPANY_EMAIL = 'contact@serviceroute.io';
export const PRIVACY_EMAIL = 'privacy@serviceroute.io';
export const CURRENT_YEAR = new Date().getFullYear();

/**
 * Footer navigation links
 */
export const FOOTER_LINKS: NavLink[] = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms of Service', path: '/tos' },
  { label: 'Data Deletion', path: '/data-deletion' },
  { label: 'Hello', path: '/hello' },
];
